__turbopack_context__.v({
  "base": "_40MJAW_base",
  "circle": "_40MJAW_circle",
  "square": "_40MJAW_square",
});
